import * as types from './types';

const INITIAL_STATE = {
  appComparisonState: {
    data: null,
    error: null,
    loading: false,
  },
  duplicateApplicationsState: {
    data: [],
    error: null,
    loading: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_ERROR:
      return {
        ...state,
        appComparisonState: {
          ...state.appComparisonState,
          error: payload,
        },
      };

    case types.DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_LOADING:
      return {
        ...state,
        appComparisonState: {
          ...state.appComparisonState,
          loading: payload,
        },
      };

    case types.DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_SUCCESS:
      return {
        ...state,
        appComparisonState: {
          ...state.appComparisonState,
          data: payload,
        },
      };

    case types.DUPLICATE_APPS_GET_DUPLICATE_APPS_LOADING:
      return {
        ...state,
        duplicateApplicationsState: {
          ...state.duplicateApplicationsState,
          loading: payload,
        },
      };

    case types.DUPLICATE_APPS_GET_DUPLICATE_APPS_SUCCESS:
      return {
        ...state,
        duplicateApplicationsState: {
          ...state.duplicateApplicationsState,
          data: payload,
        },
      };

    case types.DUPLICATE_APPS_GET_DUPLICATE_APPS_ERROR:
      return {
        ...state,
        duplicateApplicationsState: {
          ...state.duplicateApplicationsState,
          error: payload,
        },
      };

    case types.DUPLICATE_APPS_CLEAR_ERRORS:
      return {
        ...state,
        appComparisonState: {
          ...state.appComparisonState,
          error: null,
        },
        updateApplicationState: {
          ...state.updateApplicationState,
          error: null,
        },
        duplicateApplicationsState: {
          ...state.duplicateApplicationsState,
          error: null,
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/duplicateapps/reducer.js